import React, {useContext} from "react";
import {AppContext} from "../lib/AppContext";
import Dashboard from "./Dashboard";
import AdminDashboard from "./AdminDashboard";
import {CONSTANTS} from "../app/common/constants";
import LoginPage from "./LoginPage";

export default function DashboardSwitch(props) {

  const [context, setContext] = useContext(AppContext);

  return (
  <>
    {!context?.sessionUser?.guid?.length && <LoginPage />}
    {context?.sessionUser?.userTypeId === CONSTANTS.UTYPE_ADMIN && <AdminDashboard />}
    {context?.sessionUser?.userTypeId === CONSTANTS.UTYPE_CLIENT && <Dashboard />}
  </>
  );
}